import { render, staticRenderFns } from "./LoggedHeader.vue?vue&type=template&id=32051fef&scoped=true&"
import script from "./LoggedHeader.vue?vue&type=script&lang=js&"
export * from "./LoggedHeader.vue?vue&type=script&lang=js&"
import style0 from "./LoggedHeader.vue?vue&type=style&index=0&id=32051fef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32051fef",
  null
  
)

export default component.exports